import NewspaperSelect from './NewspaperSelect'

export default NewspaperSelect
